<template>
  <span style="color: transparent; userSelect: none;">{{ (new Array(size)).fill(isFullWidth ? '＿' : '_', 0).join('') }}</span>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      required: true
    },
    isFullWidth: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tool/invisible.vue